import React from "react";
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import countries from "./countries.json";

type Props = {
    value?: string;
    onChange: (country: string) => void;
};

const CountrySelect = ({ value, onChange }: Props) => {
    const handleChange = (event: SelectChangeEvent<string>) => {
        onChange(event.target.value);
    };

    return (
        <FormControl fullWidth>
            <InputLabel>Country *</InputLabel>
            <Select value={value ?? ""} label="Country *" onChange={handleChange}>
                {countries.map((country) => (
                    <MenuItem key={country.code} value={country.name}>
                        {country.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default CountrySelect;
